import styled from 'styled-components';

export const BadgeWrapper = styled.div`
  position: absolute;
  right: 3.5em;
`;
